import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { IconButton, CssBaseline, Dialog, DialogTitle, DialogContent } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { QRCodeSVG } from 'qrcode.react';
import AdminView from './views/AdminView';
import KasseView from './views/KasseView';
import ZubereitungView from './views/ZubereitungView';
import SelfServiceView from './views/SelfServiceView';
import { ThemeProvider, useTheme } from './theme/ThemeContext';
import 'bootstrap/dist/css/bootstrap.min.css';

function NavigationBar() {
  const location = useLocation();
  const { darkMode, toggleDarkMode } = useTheme();
  const [showQRCode, setShowQRCode] = useState(false);
  const isAdminPage = location.pathname === '/admin' || location.pathname === '/';

  const selfServiceUrl = window.location.origin + '/self-service';

  if (!isAdminPage) {
    return null;
  }

  return (
    <>
      <Navbar bg={darkMode ? "dark" : "light"} variant={darkMode ? "dark" : "light"} expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/">Nik's Getränke App</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/admin">Verwaltung</Nav.Link>
              <Nav.Link as={Link} to="/kasse">Kasse</Nav.Link>
              <Nav.Link as={Link} to="/zubereitung">Zubereitung</Nav.Link>
              <Button 
                variant={darkMode ? "outline-light" : "outline-dark"}
                onClick={() => setShowQRCode(true)}
                className="ms-2"
              >
                QR-Code für Selbstbedienung
              </Button>
            </Nav>
            <IconButton onClick={toggleDarkMode} color="inherit">
              {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Dialog open={showQRCode} onClose={() => setShowQRCode(false)}>
        <DialogTitle>QR-Code für Selbstbedienung</DialogTitle>
        <DialogContent>
          <div className="text-center p-4">
            <QRCodeSVG value={selfServiceUrl} size={256} />
            <p className="mt-3">
              Scannen Sie diesen Code um zur Selbstbedienung zu gelangen
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

function AppContent() {
  const { darkMode } = useTheme();
  
  return (
    <div style={{ 
      backgroundColor: darkMode ? '#303030' : '#f5f5f5',
      minHeight: '100vh',
      color: darkMode ? '#ffffff' : '#000000'
    }}>
      <NavigationBar />
      <Container>
        <Routes>
          <Route path="/" element={<AdminView />} />
          <Route path="/admin" element={<AdminView />} />
          <Route path="/kasse" element={<KasseView />} />
          <Route path="/zubereitung" element={<ZubereitungView />} />
          <Route path="/self-service" element={<SelfServiceView />} />
        </Routes>
      </Container>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
